/**
 * Generates a random number between the given range (min and max included).
 *
 * @param min A number representing the minimum value of the range (included).
 * @param max A number representing the maximum value of the range (included).
 * @returns A random number between the given range.
 */
export const randomNumber = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1) + min);
};

export const sumArray = (numbers: number[]): number =>
  numbers.reduce((total, value) => total + value, 0);

export const sumCounts = (counts: { count: number }[]): number =>
  sumArray(counts.map(({ count }) => count));
